__turbopack_context__.v({
  "icon": "CryptoIcon-module-scss-module__2Xi1tW__icon",
});
